"use client";
import React, { useState } from "react";

const InsightsData = () => {
  const [asspectsFilterBtn, setAsspectsFilterBtn] =
    useState("Positive Aspects");
  const [openAsspectsSection, setOpenAsspectsSection] =
    useState("Increasing Revenue");

  const handleAsspectsFilter = (asspects) => {
    setAsspectsFilterBtn(asspects);
  };

  const handleToggle = (section) => {
    setOpenAsspectsSection((prevSection) =>
      prevSection === section ? null : section
    );
  };

  return (
    <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[393px] h-max rounded-lg">
      <div className="flex justify-center">
        <div className="flex w-max  border border-[#C3D5DC] items-center  gap-4  mb-2  rounded-full">
          <button
            onClick={() => handleAsspectsFilter("Positive Aspects")}
            className={`text-xs font-bold pl-3 py-2 text-[#333333] ${
              asspectsFilterBtn === "Positive Aspects"
                ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                : ""
            }`}
          >
            Positive Aspects
          </button>
          <button
            className={`text-xs font-bold pl-1 py-2 pr-3 text-[#333333] ${
              asspectsFilterBtn === "Negative Aspects"
                ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                : ""
            }`}
            onClick={() => handleAsspectsFilter("Negative Aspects")}
          >
            Negative Aspects
          </button>
        </div>
      </div>

      {asspectsFilterBtn === "Positive Aspects" ? (
        <>
          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Return Consistency"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Return Consistency")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Return Consistency</p>
              {openAsspectsSection !== "Return Consistency" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Return Consistency" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  The company&apos;s revenue has been growing steadily over the
                  past 12 months, indicating a positive trend in its business
                  operations.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Return Outperformance "
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Return Outperformance ")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Return Outperformance </p>
              {openAsspectsSection !== "Return Outperformance " ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Return Outperformance " && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  Interest income has also been rising, suggesting growth in the
                  company&apos;s lending or investment activities.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Return/Risk"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Return/Risk")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Return/Risk</p>
              {openAsspectsSection !== "Return/Risk" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Return/Risk" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  The company has maintained a strong financing margin of 16-18%
                  over the past year, indicating efficient use of funds for
                  profitability.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Volatility Protection "
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Volatility Protection ")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Volatility Protection </p>
              {openAsspectsSection !== "Volatility Protection " ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Volatility Protection " && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Other income, which typically includes dividends and capital
                  gains, has been increasing, adding to the company&apos;s
                  overall profit
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Chance"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Chance")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Chance</p>
              {openAsspectsSection !== "Chance" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Chance" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  The EPS has remained relatively stable over the past 12
                  months, indicating a consistent performance.
                </p>
              </div>
            )}
          </div>
        </>
      ) : asspectsFilterBtn === "Negative Aspects" ? (
        <>
          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#D30D0040]   ${
              openAsspectsSection === "Exit Load"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Exit Load")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Exit Load</p>
              {openAsspectsSection !== "Exit Load" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Exit Load" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#D30D0040]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Has significantly declined from a peak of 18% in December 2022
                  to -3% in March 2024, indicating a sharp erosion in the
                  company&apos;s profitability.
                </p>
              </div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default InsightsData;
